export var BUTTON = 'button-base';
export var BUTTON_SIZES = {
  xs: 'button-xs',
  s: 'button-s',
  m: 'button-m',
  l: 'button-l',
  xl: 'button-xl'
};
export var BUTTON_SIZES_WITH_ICON = {
  xs: 'button-xs-with-icon',
  s: 'button-s-with-icon',
  m: 'button-m-with-icon',
  l: 'button-l-with-icon',
  xl: 'button-xl-with-icon'
};